import * as React from 'react';

import PropTypes from 'prop-types';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ThreadBadge';

function getTranslations() {
  return {
    INSTRUCTOR_CREATED: _t('Instructor Created'),
    STAFF_CREATED: _t('Staff Created'),
    INSTRUCTOR_RESPONDED: _t('Instructor Replied'),
    MENTOR_CREATED: _t('Mentor Created'),
    STAFF_RESPONDED: _t('Staff Replied'),
    MENTOR_RESPONDED: _t('Mentor Replied'),
    HIGHLIGHTED: _t('Highlighted'),
  };
}

class ThreadBadge extends React.Component {
  static propTypes = {
    badge: PropTypes.string,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'badge' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { badge } = this.props;
    const translations = getTranslations();
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const text = translations[badge];

    if (!text) {
      return null;
    }

    return (
      <span className="rc-ThreadBadge bgcolor-accent-brown-light" aria-label={text}>
        {text}
      </span>
    );
  }
}

export default ThreadBadge;
